module.exports = __webpack_public_path__ + "img/schedule_sp.6284a9d4.svg";